export const DEFAULT_SHOWCASE_QUERY = {
  forceCollectionUri: true,
};

export const VIDEOS_API_VERSION = '3.4.12';

export const ShowcaseAuthErrorCode = {
  passwordPrivacy: 0,
  incorrectPassword: 1,
  teamPrivacy: 2,
  teamPrivacyLoggedInUser: 3,
  embedOnly: 4,
  unknownReason: 5,
  unlisted: 6,
} as const;

export const GET_ALBUM_VIDEO_HEADER_VERSION = 'application/vnd.vimeo.albumvideo';

export const GET_ALBUM_SIGNATURE_PREFIX_KEY = 'album-signature';
